// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28zmG","importantInfo":"styles_importantInfo__21f0F"};